import {
  atomFamily,
  selectorFamily
} from 'recoil';
import * as vodaLend from '../api/vodaLend';

export const fetchState = selectorFamily({
  key: 'fetchState',
  get: (businessId) => async () => {
    const res = await vodaLend.getDirectorDetails(businessId);
    return res.data;
  }
});

export const updateDirectorDetails = async (data) => {
  const res = await vodaLend.putDirectorDetails(data);
  return res.data;
};

export const directorDetailsState = atomFamily({
  key: 'directorDetailsState',
  default: fetchState
});

export const directorDetailsSubmit = selectorFamily({
  key: 'directorDetailsSubmit',
  get: (businessId) => ({ get }) => {
    return get(directorDetailsState(businessId));
  },
  set: (businessId) => ({ set }, inputData) => {
    set(directorDetailsState(businessId), inputData);
  }
});
